import React from 'react';
import { StringField, StringFieldProps } from './StringField';

export type ComboFieldProps = StringFieldProps & {

}

export function ComboField (props: ComboFieldProps) {
    return (
        <StringField {...props} select />
    )
}